export function parsePrice(value: any): number | string | null {
    if (value == null || value === "") {
      return 0
    }
  
    const valueStr = value.toString();
  
    if (valueStr.includes(",")) {
      return parseFloat(
        valueStr.replace(/\./g, "").replace(",", ".") || "0"
      );
    }
  
    return value;
  }